import { defineMessages } from 'react-intl';

export const mcpStepsMessages = defineMessages({
  ariaLabel: {
    id: 'oauth.mcp.steps.ariaLabel',
    defaultMessage: 'Consent steps',
    description: 'Aria label for the list of steps in the two-step MCP consent',
  },
  selectStep: {
    id: 'oauth.mcp.steps.select',
    defaultMessage: 'Select sites and workspaces',
    description:
      'First step of the MCP consent: choosing the sites and workspaces to grant access to',
  },
  reviewStep: {
    id: 'oauth.mcp.steps.review',
    defaultMessage: 'Review permissions',
    description:
      'Second step of the MCP consent: reviewing the permissions to be granted',
  },
});
